import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';
import { Link } from 'react-router';

export const HowItWorksPage = () => {
  const { isAuthenticated, login } = useAuth();

  return (
    <div className='container mx-auto px-4 py-8'>
      <div className='max-w-4xl mx-auto'>
        {/* Header */}
        <div className='text-center mb-12'>
          <h1 className='text-4xl font-bold text-cyan-700 mb-4'>So funktioniert's</h1>
          <p className='text-xl text-gray-600'>In wenigen Schritten zu Ihren exklusiven Gutscheinen</p>
        </div>

        {/* Steps */}
        <div className='space-y-8 mb-12'>
          <Card>
            <CardHeader>
              <div className='flex items-center space-x-4'>
                <div className='w-10 h-10 bg-cyan-600 text-white rounded-full flex items-center justify-center font-bold text-lg'>
                  1
                </div>
                <div>
                  <CardTitle>Registrieren & Anmelden</CardTitle>
                  <CardDescription>Erstellen Sie Ihr kostenloses Konto bei den Stadtwerken Düren</CardDescription>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <p className='text-gray-600'>
                Die Registrierung ist kostenlos und dauert nur wenige Minuten. Nach der Anmeldung haben Sie sofort
                Zugang zu allen verfügbaren Gutscheinen.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <div className='flex items-center space-x-4'>
                <div className='w-10 h-10 bg-cyan-600 text-white rounded-full flex items-center justify-center font-bold text-lg'>
                  2
                </div>
                <div>
                  <CardTitle>Gutscheine entdecken</CardTitle>
                  <CardDescription>Durchstöbern Sie die verfügbaren Angebote unserer Partner</CardDescription>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <p className='text-gray-600'>
                Nutzen Sie die Suchfunktion oder durchstöbern Sie die Kategorien, um interessante Gutscheine zu finden.
                Jeder Gutschein zeigt alle wichtigen Details wie Gültigkeitsdauer und Einlösebedingungen.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <div className='flex items-center space-x-4'>
                <div className='w-10 h-10 bg-cyan-600 text-white rounded-full flex items-center justify-center font-bold text-lg'>
                  3
                </div>
                <div>
                  <CardTitle>Gutscheine sammeln</CardTitle>
                  <CardDescription>Fügen Sie interessante Gutscheine zu "Meine Gutscheine" hinzu</CardDescription>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <p className='text-gray-600'>
                Klicken Sie auf "Gutschein hinzufügen", um ihn in Ihrer persönlichen Sammlung zu speichern. So haben Sie
                alle Ihre Gutscheine an einem Ort.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <div className='flex items-center space-x-4'>
                <div className='w-10 h-10 bg-cyan-600 text-white rounded-full flex items-center justify-center font-bold text-lg'>
                  4
                </div>
                <div>
                  <CardTitle>Gutscheine einlösen</CardTitle>
                  <CardDescription>Lösen Sie Ihre Gutscheine beim jeweiligen Partner ein</CardDescription>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <p className='text-gray-600'>
                Gehen Sie zu "Meine Gutscheine" und wählen Sie den Gutschein aus, den Sie einlösen möchten. Folgen Sie
                den Anweisungen des Anbieters zur Einlösung - online oder vor Ort.
              </p>
            </CardContent>
          </Card>
        </div>

        {/* FAQ Section */}
        <div className='mb-12'>
          <h2 className='text-2xl font-bold text-cyan-700 mb-6 text-center'>Häufig gestellte Fragen</h2>
          <div className='space-y-4'>
            <Card>
              <CardHeader>
                <CardTitle className='text-lg'>Kostet die Nutzung etwas?</CardTitle>
              </CardHeader>
              <CardContent>
                <p className='text-gray-600'>
                  Nein, die Registrierung und Nutzung der Gutschein-Plattform ist völlig kostenlos für alle Kunden der
                  Stadtwerke Düren.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className='text-lg'>Wie lange sind die Gutscheine gültig?</CardTitle>
              </CardHeader>
              <CardContent>
                <p className='text-gray-600'>
                  Jeder Gutschein hat eine individuelle Gültigkeitsdauer, die beim Gutschein angezeigt wird. Abgelaufene
                  Gutscheine können nicht mehr eingelöst werden.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className='text-lg'>Kann ich Gutscheine übertragen?</CardTitle>
              </CardHeader>
              <CardContent>
                <p className='text-gray-600'>
                  Gutscheine sind personengebunden und können nicht an andere Personen übertragen werden. Jeder Nutzer
                  kann nur seine eigenen Gutscheine einlösen.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* CTA */}
        <div className='text-center'>
          {!isAuthenticated ? (
            <div className='space-y-4'>
              <h3 className='text-xl font-semibold text-gray-800'>Bereit zum Sparen?</h3>
              <Button onClick={login} size='lg' className='bg-cyan-600 hover:bg-cyan-700'>
                Jetzt kostenlos registrieren
              </Button>
            </div>
          ) : (
            <div className='space-y-4'>
              <h3 className='text-xl font-semibold text-gray-800'>Entdecken Sie jetzt verfügbare Gutscheine!</h3>
              <Button asChild size='lg' className='bg-cyan-600 hover:bg-cyan-700'>
                <Link to='/coupons'>Zu den Gutscheinen</Link>
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
